var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibilityOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.97723 2L1.87804 3.08126L16.0227 17L17.1219 15.9184L2.97723 2Z",
    fill: "#inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.20032 5.3662L5.23492 6.38424C4.10236 7.33314 3.20051 8.51428 2.61773 9.54769L2.61595 9.55118C4.23901 12.2215 6.81431 14.7451 10.0647 14.3624C10.942 14.259 11.7605 13.9639 12.5083 13.5416L13.5557 14.5719C12.098 15.4925 10.4271 15.9801 8.6166 15.7391C5.35204 15.3046 2.68268 12.6699 1 9.57563C1.79005 8.01137 2.87079 6.51486 4.20032 5.3662ZM6.55345 3.85747C7.4663 3.45723 8.45405 3.22184 9.50887 3.20508C9.56744 3.20473 10.2627 3.23721 10.5779 3.2882C10.7756 3.32033 10.9726 3.36049 11.1667 3.41044C14.2634 4.20427 16.5576 6.78029 18 9.43419C17.3949 10.6366 16.6023 11.8101 15.6572 12.8156L14.6538 11.8282C15.3519 11.0879 15.934 10.2636 16.3823 9.46422C16.3823 9.46422 15.9315 8.75106 15.5897 8.30334C15.37 8.01556 15.139 7.73616 14.8962 7.4669C14.7046 7.25456 13.9603 6.53337 13.7832 6.3832C12.5949 5.37772 11.1997 4.58878 9.52626 4.60205C8.87818 4.61218 8.25494 4.73791 7.66328 4.94955L6.55345 3.85747Z",
    fill: "#inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.01662 8.13802L7.8153 8.9236L10.8895 11.9486C10.4785 12.1756 10.0043 12.3048 9.5 12.3048C7.92948 12.3048 6.6546 11.0504 6.6546 9.50496C6.6546 9.00869 6.78628 8.54245 7.01662 8.13802ZM9.44747 6.70578C9.46487 6.70543 9.48261 6.70508 9.5 6.70508C11.0705 6.70508 12.3454 7.95991 12.3454 9.50496C12.3454 9.52242 12.3454 9.53954 12.345 9.55665L9.44747 6.70578Z",
    fill: "#inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOff);
export default __webpack_public_path__ + "static/media/visibility_off.2760f54351ee4c8ed19955ef22469815.svg";
export { ForwardRef as ReactComponent };